import { IconoirHelpCircle } from "@ey-xd/motif-icon";
import { MotifIcon } from "@ey-xd/motif-react";
import "./LearnAboutBillingPeriods.scss";
import { BILLING_PREVIEW_LINK } from "../../../../../../Constant";

const LearnAboutBillingPeriods = () => (
  <div className="billing-period-container">
    <a
      className="billing-period-link"
      href={BILLING_PREVIEW_LINK}
      target="_blank"
      rel="noreferrer"
    >
      <MotifIcon iconFunction={IconoirHelpCircle} size="20" fill="#85B9FD" />
      <span>Learn more about billing periods</span>
    </a>
  </div>
);

export default LearnAboutBillingPeriods;
